module.exports = __webpack_public_path__ + "img/horse-portrait-painting-fail.b901cb99.png";